import services from 'services/services';
import * as types from '../types';
import { setRequestUrl } from 'store/actions';

// Import helpers
import {
	checkFetchErrors,
	queryParams
} from '../helpers_actions/convert_helpers';

// Import variables
import { TABLE_LENGTH } from 'components/helpers/table';

// ******************** FETCH GEOLOCKS - TABLE DATA ********************
export const fetchGeolocks = (options) => async (dispatch, getState) => {
	try {
		// Dispatch a loading action
		dispatch({
			type: types.FETCH_GEOLOCKS_LOADING,
			payload: true
		});

		const {
			geolocks: {
				table: {
					columns,
					options: {
						filters: { filterUrlQuery },
						startIndex: startTableIndex,
						page
					}
				}
			}
		} = getState();

		const startIndex =
			options.page === page ? startTableIndex : options.startIndex;

		const url = `/player/ipAddress/list?${filterUrlQuery}${queryParams(
			options,
			TABLE_LENGTH,
			columns,
			startIndex
		)}`;

		const { data } = await services.get(url);

		// Calculate pages
		const pages = Math.ceil(data.recordsFiltered / TABLE_LENGTH);

		// Dispatch an action with data
		dispatch({
			type: types.FETCH_GEOLOCKS_SUCCESS,
			payload: { ...data, pages, page: options.page, startIndex }
		});

		// save request url in redux
		setRequestUrl(url)(dispatch);
	} catch (error) {
		dispatch({
			type: types.FETCH_GEOLOCKS_ERROR,
			payload: checkFetchErrors(error)
		});
	}
};

// ******************** DELETE GEOLOCK ********************
export const deleteGeolock = (id) => async (dispatch) => {
	try {
		// Dispatch a loading action
		dispatch({
			type: types.DELETE_GEOLOCK_LOADING,
			payload: true
		});

		await services.delete(`/player/ipAddress/${id}/delete`);
		// Dispatch an action with data
		dispatch({
			type: types.DELETE_GEOLOCK_SUCCESS,
			payload: true
		});
	} catch (error) {
		// Dispatch an action with error set to true
		dispatch({
			type: types.DELETE_GEOLOCK_ERROR,
			payload: checkFetchErrors(error)
		});
	}
};

// ******************** SET SEARCH QUERY ********************
export const setGeolocksQuery = (query) => ({
	type: types.SET_GEOLOCKS_SEARCH_QUERY,
	payload: query
});
